import React from 'react';
import _ from 'lodash';
import { Tooltip } from 'barnyard/components';
import { BarnyardIcon } from 'barnyard/icons';

export const BUYER_PERMISSIONS_OBJECT = {
  USER_MANAGEMENT_FULL: {
    value: 'USER_MANAGEMENT_FULL',
    label: <>
      <span className='u-marginRight5'>User Management</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='Users can add and remove other users from this account, and change a user&apos;s permission levels.'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'User Management'
  },
  CASHBACK_FULL: {
    value: 'CASHBACK_FULL',
    label: <>
      <span className='u-marginRight5'>Claim Vetcove Rewards</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='Users can redeem Cash Back earned for Vetcove rewards.'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'Claim Vetcove Rewards'
  },
  ANALYTICS_READ: {
    value: 'ANALYTICS_READ',
    label: <>
      <span className='u-marginRight5'>View Analytics</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='Users can view and analyze a clinic&apos;s purchase history and trends.'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'View Analytics'
  },
  ORDERS_FULL: {
    value: 'ORDERS_FULL',
    label: <>
      <span className='u-marginRight5'>Place Orders</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='Users can place orders with any connected suppliers.'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'Place Orders'
  },
  CARTS_FULL: {
    value: 'CARTS_FULL',
    label: <>
      <span className='u-marginRight5'>Add/Modify Carts</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='Users can add, update, and remove items from supplier carts.'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'Add/Modify Carts'
  },
  PURCHASES_READ: {
    value: 'PURCHASES_READ',
    label: <>
      <span className='u-marginRight5'>View Previous Purchases</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='This permission allows you to view the purchase history of a clinic.'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'View Previous Purchases'
  },
  PRICING_READ: {
    value: 'PRICING_READ',
    label: <>
      <span className='u-marginRight5'>View Pricing &amp; Stock</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='Users can view your clinic&apos;s pricing and availability on any item.'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'View Pricing & Stock'
  },
  MARK_RECEIVED: {
    value: 'MARK_RECEIVED',
    label: <>
      <span className='u-marginRight5'>Receive Invoices</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='Users can mark packing slips and invoices as received.'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'Receive Invoices'
  },
  MANAGE_VENDORS: {
    value: 'MANAGE_VENDORS',
    label: <>
      <span className='u-marginRight5'>Manage Vendors</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='Users can connect/disconnect vendors as well as change or claim subaccounts.'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'Manage Vendors'
  },
  CASHBACK_READ: {
    value: 'CASHBACK_READ',
    label: <>
      <span className='u-marginRight5'>View Cashback Rewards</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='Users can view the cashback page.'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'View Cashback Rewards'
  },
  SCRIPTS_READ: {
    value: 'SCRIPTS_READ',
    label: <>
      <span className='u-marginRight5'>View Scripts</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='Users can view scripts tool'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'View Scripts'
  },
  PUNCHOUTS: {
    value: 'PUNCHOUTS',
    label: <>
      <span className='u-marginRight5'>Punchouts</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='Users can access and place orders via punchouts.'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'Punchouts'
  },
  LISTS_FULL: {
    value: 'LISTS_FULL',
    label: <>
      <span className='u-marginRight5'>Edit Shopping Lists</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='Users can create, edit, and delete shopping lists'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'Edit Shopping Lists'
  },
  RECEIVE_ORDERS: {
    value: 'RECEIVE_ORDERS',
    label: <>
      <span className='u-marginRight5'>Receive Orders</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='Users can mark packing slips and orders as received'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'Receive Orders'
  },
  BUDGETS_FULL: {
    value: 'BUDGETS_FULL',
    label: <>
      <span className='u-marginRight5'>Edit Budgets</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='User has the ability to edit clinic&apos;s budgets.'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'Edit Budgets'
  },
  ACCOUNT_SETTINGS_FULL: {
    value: 'ACCOUNT_SETTINGS_FULL',
    label: <>
      <span className='u-marginRight5'>Manage Clinic Account Settings</span>{' '}
      <Tooltip
        className='rPermissions__tooltip'
        direction='left'
        body='This permission allows you to modify Vetcove Account Settings for the clinic.'
      >
        <BarnyardIcon icon={['fal', 'question-circle']} />
      </Tooltip>
    </>,
    description: 'Manage Clinic Account Settings'
  },
};


export const ALL_PERMISSIONS_FULL = {
  value: 'ALL_PERMISSIONS_FULL',
  description: 'All Permissions Access'
};

export const PERMISSION_GROUPS = {
  PRIMARY: {
    name: 'Admin',
    value: 'Admin - gives users permission to access everything in Vetcove',
    key: 'PRIMARY',
    permissions: [
      BUYER_PERMISSIONS_OBJECT.PRICING_READ.value,
      BUYER_PERMISSIONS_OBJECT.PURCHASES_READ.value,
      BUYER_PERMISSIONS_OBJECT.CARTS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.ORDERS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.ANALYTICS_READ.value,
      BUYER_PERMISSIONS_OBJECT.USER_MANAGEMENT_FULL.value,
      BUYER_PERMISSIONS_OBJECT.CASHBACK_FULL.value,
      BUYER_PERMISSIONS_OBJECT.MARK_RECEIVED.value,
      BUYER_PERMISSIONS_OBJECT.MANAGE_VENDORS.value,
      BUYER_PERMISSIONS_OBJECT.CASHBACK_READ.value,
      BUYER_PERMISSIONS_OBJECT.SCRIPTS_READ.value,
      BUYER_PERMISSIONS_OBJECT.LISTS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.RECEIVE_ORDERS.value,
      BUYER_PERMISSIONS_OBJECT.BUDGETS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.ACCOUNT_SETTINGS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.PUNCHOUTS.value,
    ]
  },
  FULL: {
    name: 'Manager',
    value: 'Manager - gives users access to item pricing, past purchases, modifying carts, placing orders, and viewing analytics',
    key: 'FULL',
    permissions: [
      BUYER_PERMISSIONS_OBJECT.PRICING_READ.value,
      BUYER_PERMISSIONS_OBJECT.PURCHASES_READ.value,
      BUYER_PERMISSIONS_OBJECT.CARTS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.ORDERS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.ANALYTICS_READ.value,
      BUYER_PERMISSIONS_OBJECT.MARK_RECEIVED.value,
      BUYER_PERMISSIONS_OBJECT.CASHBACK_READ.value,
      BUYER_PERMISSIONS_OBJECT.MANAGE_VENDORS.value,
      BUYER_PERMISSIONS_OBJECT.SCRIPTS_READ.value,
      BUYER_PERMISSIONS_OBJECT.LISTS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.RECEIVE_ORDERS.value,
      BUYER_PERMISSIONS_OBJECT.BUDGETS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.ACCOUNT_SETTINGS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.PUNCHOUTS.value,
    ]
  },
  PURCHASER: {
    name: 'Purchaser',
    value: 'Purchaser - gives users access to item pricing, past purchases, modifying carts, and placing orders',
    key: 'PURCHASER',
    permissions: [
      BUYER_PERMISSIONS_OBJECT.PRICING_READ.value,
      BUYER_PERMISSIONS_OBJECT.PURCHASES_READ.value,
      BUYER_PERMISSIONS_OBJECT.CARTS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.ORDERS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.MARK_RECEIVED.value,
      BUYER_PERMISSIONS_OBJECT.CASHBACK_READ.value,
      BUYER_PERMISSIONS_OBJECT.LISTS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.PUNCHOUTS.value,
      BUYER_PERMISSIONS_OBJECT.RECEIVE_ORDERS.value,
    ]
  },
  BASIC: {
    name: 'Basic',
    value: 'Basic - gives users access to item pricing, past purchases, and modifying carts',
    key: 'BASIC',
    permissions: [
      BUYER_PERMISSIONS_OBJECT.PRICING_READ.value,
      BUYER_PERMISSIONS_OBJECT.PURCHASES_READ.value,
      BUYER_PERMISSIONS_OBJECT.CARTS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.LISTS_FULL.value,
    ]
  },
  RESTRICTED: {
    name: 'Restricted',
    value: 'Restricted - gives users access to basic Vetcove functions like searching the catalog, and joining the discussion board',
    key: 'RESTRICTED',
    permissions: []
  },
  CUSTOM: {
    name: 'Custom',
    value: 'Custom',
    key: 'CUSTOM',
    permissions: []
  }
};

export const PATHWAY_THRIVE_CUSTOM_GROUPS = {
  FULL: {
    name: 'Manager',
    value: 'Manager - gives users access to item pricing, past purchases, modifying carts, managing vendors, viewing scripts, receiving invoices, placing orders, and viewing analytics',
    key: 'FULL',
    permissions: [
      BUYER_PERMISSIONS_OBJECT.PRICING_READ.value,
      BUYER_PERMISSIONS_OBJECT.PURCHASES_READ.value,
      BUYER_PERMISSIONS_OBJECT.CARTS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.ORDERS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.ANALYTICS_READ.value,
      BUYER_PERMISSIONS_OBJECT.MARK_RECEIVED.value,
      BUYER_PERMISSIONS_OBJECT.MANAGE_VENDORS.value,
      BUYER_PERMISSIONS_OBJECT.SCRIPTS_READ.value,
      BUYER_PERMISSIONS_OBJECT.LISTS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.RECEIVE_ORDERS.value,
      BUYER_PERMISSIONS_OBJECT.BUDGETS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.PUNCHOUTS.value,
    ]
  },
  RECEIVER: {
    name: 'Receiver',
    value: 'Receiver - gives users access to item pricing, past purchases, receiving invoices, and viewing analytics',
    key: 'RECEIVER',
    permissions: [
      BUYER_PERMISSIONS_OBJECT.PRICING_READ.value,
      BUYER_PERMISSIONS_OBJECT.PURCHASES_READ.value,
      BUYER_PERMISSIONS_OBJECT.ANALYTICS_READ.value,
      BUYER_PERMISSIONS_OBJECT.MARK_RECEIVED.value,
      BUYER_PERMISSIONS_OBJECT.LISTS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.RECEIVE_ORDERS.value,
    ]
  },
  PURCHASER: {
    name: 'Purchaser',
    value: 'Purchaser - gives users access to item pricing, past purchases, modifying carts, managing vendors, viewing analytics, and placing orders',
    key: 'PURCHASER',
    permissions: [
      BUYER_PERMISSIONS_OBJECT.PRICING_READ.value,
      BUYER_PERMISSIONS_OBJECT.PURCHASES_READ.value,
      BUYER_PERMISSIONS_OBJECT.CARTS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.ORDERS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.ANALYTICS_READ.value,
      BUYER_PERMISSIONS_OBJECT.MANAGE_VENDORS.value,
      BUYER_PERMISSIONS_OBJECT.LISTS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.PUNCHOUTS.value,
    ]
  },
  BASIC: {
    name: 'Basic',
    value: 'Basic - gives users access to item pricing, past purchases, and modifying carts',
    key: 'BASIC',
    permissions: [
      BUYER_PERMISSIONS_OBJECT.PRICING_READ.value,
      BUYER_PERMISSIONS_OBJECT.PURCHASES_READ.value,
      BUYER_PERMISSIONS_OBJECT.CARTS_FULL.value,
      BUYER_PERMISSIONS_OBJECT.LISTS_FULL.value,
    ]
  },
  CUSTOM: {
    name: 'Custom',
    value: 'Custom',
    key: 'CUSTOM',
    permissions: []
  }
};

// filtering permissions by what is available to the user.
// for example, punch outs are only available to certain buyers/corporates
// restricted permissions is a mapping of permission value to whether or not it is allowed
// i.e. { [BUYER_PERMISSIONS_OBJECT.PUNCHOUTS.value]: true }
export const getFilteredPermissions = (permissions, restrictedPermissions, key = null) => (
  _.filter(
    permissions,
    (permission) => {
      if (!key) {
        return _.get(restrictedPermissions, permission, true);
      }
      return _.get(restrictedPermissions, _.get(permission, key), true);
    }
  )
);

// permissionGroups are permissions that the user has access to.
// for example, punch outs are only available to certain buyers/corporates
// so we don't want to include them when determining the group
export const getPreselectedPermissionsKeys = (permissions, permissionGroups, availablePermissions) => {
  if (!permissions) {
    return null;
  }
  // availablePermissionsKeys is an array of permissions that the user has access to
  // through their buyer/corporate. For example, punchouts are only available to
  // certain buyers/corporates
  const availablePermissionsKeys = _.map(availablePermissions, 'value');
  const sortedSelectedPermissions = _.sortBy(
    _.filter(
      permissions,
      permission => _.includes(availablePermissionsKeys, permission)
    )
  );
  if (_.includes(permissions, ALL_PERMISSIONS_FULL.value)) {
    // thrive/pathway doesnt have a primary key
    return _.get(permissionGroups, 'PRIMARY.key') || _.get(permissionGroups, 'CUSTOM.key');
  }
  let preselectedGroup = permissionGroups.CUSTOM.key;
  _.forEach(permissionGroups, (group, key) => {
    if (_.isEqual(_.sortBy(group.permissions), sortedSelectedPermissions)) {
      preselectedGroup = key;
      return false;
    }
  });
  return preselectedGroup;
};

const getShoppingPortalAccessInfo = () => (
  <>
    <span className='u-marginRight5'>Has Purchasing Platform Access</span>{' '}
    <BarnyardIcon icon={['fal', 'question-circle']} />
  </>
);

const getPharmacyPortalAccessInfo = () => (
  <>
    <span className='u-marginRight5'>Has Home Delivery Access</span>{' '}
    <BarnyardIcon icon={['fal', 'question-circle']} />
  </>
);

// Checkboxes to toggle different portal access
export const EDIT_SHOPPING_PORTAL_CHECK = getShoppingPortalAccessInfo();
export const INVITE_SHOPPING_PORTAL_CHECK = getShoppingPortalAccessInfo();
export const EDIT_PHARMACY_PORTAL_CHECK = getPharmacyPortalAccessInfo();

// PortalChoice values (match backend constant values)
export const PURCHASING_PORTAL = 'PURCHASING';
export const PHARMACY_PORTAL = 'PHARMACY';

export const initialPermissionValues = (permissions, renderFunction, permissionGroups, availablePermissions, portals) => {
  let perms = [];
  if (_.includes(permissions, ALL_PERMISSIONS_FULL.value)) {
    // thrive/pathway don't have primary permissions
    perms = _.get(permissionGroups, 'PRIMARY.permissions') || _.get(permissionGroups, 'CUSTOM.permissions');
  } else {
    perms = permissions;
  }
  return {
    permissions: perms,
    group: renderFunction(permissions, permissionGroups, availablePermissions),
    hasShoppingPortalAccess: _.get(portals, PURCHASING_PORTAL),
    hasPharmacyPortalAccess: _.get(portals, PHARMACY_PORTAL)
  };
};

export const BUYER_PERMISSIONS_ALPHABETICAL = _.orderBy(
  BUYER_PERMISSIONS_OBJECT, [permission => permission.description.toLowerCase()]
);

// Needs to match WorkmatePositions enum options on BE (app/accounts/constants.py)
export const WORKMATE_POSITIONS = [
  'Practice Manager',
  'Office Manager',
  'Practice Owner',
  'Veterinarian',
  'Hospital Director',
  'Medical Director',
  'Multi Site Hospital Director',
  'Lead Technician',
  'Surgical Technician',
  'Technician',
  'Inventory Manager',
  'Receptionist',
  'Kennel Technician',
  'Groomer',
  'Vet Assistant',
  'Inventory Purchaser',
  'Sales Representative',
  'Territory Manager',
  'Pet Parent',
  'Other Veterinary Staff',
];

